'use client';

import { cn } from '@/lib/utils';
import MarketSection from './MarketSection';
import useWorldCupExactScore from '../../hooks/use-world-cup-exact-score';
import { buildColumns, buildMarketSection } from './marketTableUtils';

export interface WorldCupDataTableProps {
  eventSlug: string;
  className?: string;
}

export default function WorldCupDataTable({ eventSlug, className }: WorldCupDataTableProps) {
  const { detail, exactScore } = useWorldCupExactScore({ eventSlug });
  const columns = buildColumns();
  const section = exactScore
    ? buildMarketSection(
        'Exact Score',
        exactScore,
        {
          icon_name: 'exact-score',
          icon_class_name: 'text-[#12B3CF]',
        },
        {
          showRowVolume: true,
          showParticipant: true,
          homeTeam: detail?.home_team,
          awayTeam: detail?.away_team,
        },
      )
    : null;

  return (
    <section
      className={cn('w-full text-white', className)}
      style={{ fontFamily: "'SF Pro', -apple-system, BlinkMacSystemFont, sans-serif" }}
    >
      {section && (
        <div className="space-y-2 overflow-x-auto pb-1">
          <div className="min-w-180 space-y-2">
            <MarketSection section={section} columns={columns} />
          </div>
        </div>
      )}
    </section>
  );
}
